import * as ResponsiveFns from './ResponsiveFns';
import * as SearchForAnEntityType from './SearchForAnEntityType';
import * as TypeEvaluation from '../TypeEvaluation';
import * as DesignerFunctions from './DesignerFunctions';
import * as CoreFns from './CoreFns';
// import * as ActionModifiers from '../ActionModifiers';
// import * as StyleFunctions from './StyleFunctions';
import * as NamingFns from './NamingFns';
import * as SearchForAnEntityWithPath from './SearchForAnEntityWithPath';

function availableGoDowns(currentList, type){
  if (type.t === 'ListType'){
    var listVariables = [{q:'Which Item', t:{t:'UInteger'},f:1, i:'iNos',c:[]}];
    figureOutGoDown(type.c, listVariables);
    return [{n:'Entire List', a:'bx:transfer', i:'all', c:[]}, 
      {n:'Item of Array', a:'bx:transfer', i:'item', c:listVariables}];
  // }else if (type.t === 'Mapping'){
  //   var mapVariables = [{q:'Pointer', t:type.fr,f:1, i:'p',c:[]}];
  //   figureOutGoDown(type.c, mapVariables);
  //   return [{n:'Entire Map', a:'bx:transfer', i:'all', c:[]}, 
  //     {n:'Specific Entry', a:'bx:transfer', i:'item', c:mapVariables}];
  // }else if (type.t === 'Object'){
  //   var childrenSet = childrenOfAStruct(currentList, type.v);
  //   if (childrenSet){
  //     var toConcat = childrenSet.keys.map((aChildKey, index)=>{
  //       var thisChild = childrenSet.functions[aChildKey];
  //       var structVariables = [];
  //       figureOutGoDown(CoreFns.convertSelectionToType(thisChild.t, currentList), structVariables);
  //       return {n:thisChild.n, a:'bx:transfer', i:aChildKey, c:structVariables}
  //     })
  //     return [{n:'Entire Struct', a:'bx:transfer', i:'all', c:[]}].concat(toConcat);      
  //   }
  }
  return [];
}

export function musicQuestions(){
  return  [{i:'mu', o:'Music', t:{t:'List', c:[
      {q:'Name', t:{t:'Text String'}, i:'n', c:[{t:'noBlank'}, {t:'startsWithLetter'}, {t:'alphaNumeric'}]},
      {q:'Url', t:{t:'Text String', o:musicOptions()}, 
        i:'src', c:[{t:'noBlank'}], d:'https://www.cues.sg/music/space.mp3'},
      {t:{t:'PlayMusic'}}
      ]}, 
      c:[{t:'uniqueEndValues',v:[{t:'path',v:'n'}],e:'Variable Names need to be unique'}]}];

}

export function musicOptions(){
  return [{i:'https://www.cues.sg/music/space.mp3', n:'A magical journey through space', c:'A Magical Journey Through Space by Leonell Cassio\nhttps://soundcloud.com/leonellcassio\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution-ShareAlike 3.0 Unported (CC BY-SA 3.0)\nhttps://creativecommons.org/licenses/by-sa/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/epic-sci-fi-trailer-eternals.mp3', n:'Epic sci-fi trailer eternals', c:'Eternals by Alex-Productions\nhttps://onsound.eu/\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/friends-forever.mp3', n:'Friends forever', c:'Music by https://www.free-stock-music.com'},
          {i:'https://www.cues.sg/music/give-me-a-smile.mp3', n:'Give me a smile', c:'Give Me A Smile by Free Music\nhttps://soundcloud.com/fm_freemusic\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/puzzle.mp3', n:'Puzzle', c:'Puzzle by Roa Music\nhttps://soundcloud.com/roa_music1031\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/sleepless-nights.mp3', n:'Sleepless nights', c:'Sleepless Nights by Roa Music\nhttps://soundcloud.com/roa_music1031\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/summer-vibes.mp3', n:'Summer vibes', c:'Summer Vibes by Mike Leite\nhttps://soundcloud.com/mikeleite\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'},
          {i:'https://www.cues.sg/music/three-sheets-to-the-wind.mp3', n:'Three sheets to the wind', c:'Three Sheets To The Wind by Scott Buckley\nhttps://soundcloud.com/scottbuckley\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 4.0 International (CC BY 4.0)\nhttps://creativecommons.org/licenses/by/4.0/'},
          {i:'https://www.cues.sg/music/untouched-land.mp3', n:'Untouched land', c:'Untouched Land by Alexander Nakarada\nhttps://www.serpentsoundstudios.com\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 4.0 International (CC BY 4.0)\nhttps://creativecommons.org/licenses/by/4.0/'},
          {i:'https://www.cues.sg/music/vacaciones.mp3', n:'Vacaciones', c:'Vacaciones by Mike Leite\nhttps://soundcloud.com/mikeleite\nMusic promoted by https://www.free-stock-music.com\nCreative Commons / Attribution 3.0 Unported License (CC BY 3.0)\nhttps://creativecommons.org/licenses/by/3.0/deed.en_US'}];

}


export function ownVariableQuestions(){
  return  [{i:'ov', o:'Variable', t:{t:'List', c:[
      {q:'Name', t:{t:'Text String'}, i:'n', c:[{t:'noBlank'}, {t:'startsWithLetter'}, {t:'alphaNumeric'}]},
      {q:'Type', t:{t:'Type'}, i:'t', c:[]},
      {q:'Initial Value', h:'This is the starting value of the variable', t:{back:0, fwd:['t']}, i:'d', f:1, c:[]}]}, c:[{t:'uniqueEndValues',v:[{t:'path',v:'n'}],e:'Variable Names need to be unique'}]}];

}


export function ownStructQuestions(){
  return  [{i:'os', o:'Struct', t:{t:'List', c:[
      {q:'Name', t:{t:'Text String'}, i:'n', c:[{t:'noBlank'}]},

      {i:'s', o:'Item', t:{t:'List', c:[
          {q:'Item Name', t:{t:'Text String'}, i:'n', c:[{t:'noBlank'}, {t:'startsWithLetter'}, {t:'alphaNumeric'}]},
          {q:'Type', t:{t:'Type'}, i:'t', c:[]}]}, c:[{t:'uniqueEndValues',v:[{t:'path',v:'n'}],e:'Item Names need to be unique'}]}

      ]}, c:[{t:'uniqueEndValues',v:[{t:'path',v:'n'}],e:'Struct Names need to be unique'}]}];

}


    //     
    //     ]}, ]}


function figureOutGoDown(type, cVariables){
  if (type.t === 'ListType' || type.t === 'Object'){
    cVariables.push({q:'Variable Aspect',t:{t:'GoDown',v:type},i:'aspect'})
  }
}

export function isDynamicChoice(type){
  return type.t === 'Type' || type.t === 'GoDown' || type.t === 'AvailableStruct' || type.t === 'TemplateCondition';
}

export function actionOptionChoices(type, currentList, here){

  if (type.t === 'Type'){
    return availableTypes(currentList, type.source);
  }else if (type.t === 'GoDown'){
    return availableGoDowns(currentList, type.v);
  }else if (type.t === 'AvailableStruct'){
    return availableStructs(currentList);
  }else if (type.t === 'TemplateCondition'){
    return availableTemplateConditions(type.v);
  }
}



export function getComments(contractInfo, tgt){

  function removeStartStar(text){
    if (text.indexOf('*') === 0){
      return text.substr(1).trim();
    }else{
      return text;
    }
  }
  var code = CoreFns.getCodeFromContractInfo(contractInfo);
  if (!code){
    return false;
  }
  var abi = CoreFns.getAbiFromContractInfo(contractInfo);
  var code1 = code.split('\r').join('\n');
  var codeLines = code1.split('\n');
  var functionalComments = [];

  var isInComments = false;

  for (var i5 = 0; i5 < codeLines.length; i5++){
    var thisLine = codeLines[i5].trim();
    if (isInComments){
      var p = thisLine.indexOf('*/');
      if (p > -1){
        var b4 = thisLine.substr(0, p + 2);
        var aft = thisLine.substr(p + 2);
        functionalComments.push(removeStartStar(b4));
        isInComments = false;
        codeLines[i5] = aft;
        i5 --;
      }else{
        functionalComments.push(removeStartStar(thisLine));
      }

    }else{
      if (thisLine.indexOf('//') === 0){
        functionalComments.push(removeStartStar(thisLine.substr(2)));
      }else if (thisLine.indexOf('function ') === 0){

        if (tgt.t === 'function'){
          var functionName;
          if (tgt.nos === 0 || tgt.nos > 0){
            var thisFunction = abi[tgt.nos];
            functionName = thisFunction.name;
          }else{
            functionName = tgt.nos;
          }

          var beyond = thisLine.substr(9).trim();
          if (beyond.indexOf(functionName) === 0){
            var textList = functionalComments.filter((aC, index)=>{
              return aC
            });
            if (textList.length > 0){
              return {textList, functionName};
            }else{
              return false;
            }
          }else{
            functionalComments = [];
          }

        }
      }else if (thisLine.indexOf('contract') === 0){
        if (tgt.t === 'general'){
          var textList1 = functionalComments.filter((aC, index)=>{
            return aC
          });
          if (textList1.length > 0){
            return {textList:textList1};
          }else{
            return false;
          }
        }

        functionalComments = [];
      }else if (thisLine.indexOf('constructor') === 0){
        functionalComments = [];
      }else if (thisLine.indexOf('/*') === 0){
        functionalComments.push(thisLine.substr(2));
        isInComments = true;
      }
    }
  }
}

export function getAParticularContractValue(textSet, tgt){
  for (var i = 0; i < textSet.length; i++){
    if (textSet[i].indexOf(tgt + ' : ') === 0){
      return textSet[i].substr(tgt.length + 3);
    }
  }
  return false;
}

export function getFunctionExists(currentList, scKey, functionName){
  var thisSC = currentList.sc[scKey];
  if (thisSC){
    var addSet = thisSC.addSet;
    var addSetKeys = Object.keys(addSet);
    var contractInfo = addSet[addSetKeys[0]];
    var abi = CoreFns.getAbiFromContractInfo(contractInfo);
    var thisFn = CoreFns.getAbiFnInfo(abi, functionName, true);
    if (thisFn){
      return true;
    }
  }
  return false;
}


function availableTemplateConditions(conType){
  if (conType === 'StakingCoinCurrency'){
    return [{n:'No Referral Scheme', i:'noRefferal', c:[]}];
  }else if (conType === 'Exchange'){
    return [{n:'No Reverse Exchange', i:'noReverse', c:[]}];
  }

  return [];
}


function availableStructs(currentList){
  var os = currentList.os;
  var osKeys = CoreFns.sortedKeyList(os);
  return osKeys.map((aKey, index)=>{
   var aStruct = os[aKey];
   return {n:'Struct ' + aStruct.n, i:aKey, c:[]};
  })
}

  function compare(a, b) {
    if (a.n < b.n) {
      return -1;
    }
    if (a.n > b.n) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

function availableTypes(currentList, source){

  var o = [{n:'Integer',i:'Integer', c:[]},
            {n:'Positive integer / 0',i:'UInteger',c:[]},
            {n:'Date Time',i:'Date Time',c:[]},
            {n:'Blockchain Address',i:'Address',c:[]},
            {n:'Blockchain Transaction',i:'Transaction',c:[]},
            {n:'Boolean i.e. True/False',i:'Boolean',c:[]},
            {n:'Decimal',i:'Decimal',c:[]},
            {n:'Text / String',i:'Text String',c:[]},
            {n:'List',i:'ListType',c:[{q:'List Type', t:{t:'Type',source}, i:'t',c:[]}]}
        ];

  var os = currentList.os;
  if (os){
    var osKeys = CoreFns.sortedKeyList(os);
    if (osKeys.length > 0){
      o.push({n:'Struct', i:'Struct', c:[
          {q:'Which Struct', t:{t:'AvailableStruct'}, i:'st', c:[]}
        ]})   
    }
  }

  o.forEach((anO, index)=>{
    anO.a = CoreFns.iconFromType({t:anO.i});
  })
  return o.sort(compare);
}

function checkGotBytes(inputsList){
  for (var i = 0; i < inputsList.length; i++){
    var thisInput = inputsList[i];
    if (thisInput && thisInput.internalType && thisInput.internalType.indexOf('bytes') === 0){
      return true;
    }
  }
  return false;
}

export function actionOptions(currentList, path){


  var actions = [
      {i:'connectWallet', n:'Connect Wallet', a:':bx:wallet'}, 
      {i:'alert', n:'Pop Up Alert', a:'akar-icons:circle-alert'},
       {i:'prompt', n:'Prompt user for input', a:'tabler:prompt'}, 
       {i:'confirm', n:'Ask user for confirmation', a:'line-md:circle-to-confirm-circle-transition'}, 
       {i:'ifThenElse', n:'If Then Else', a:'fluent:arrow-split-16-regular'}, 
       {i:'copyText', n:'Copy text to clipboard', a:'akar-icons:copy'}, 
       {i:'delay', n:'Delay action', a:'mdi:speedometer-slow'}, 
       // {i:'writeToDatabase', n:'Write value to database', a:'ant-design:database-outlined'}, 
       {i:'openPopUp', n:'Open a Pop Up Window', a:'carbon:popup'}, 
       {n:'Update Variable', a:'radix-icons:update', i:'updateVar'},
       {i:'placeholder', n:'Placeholder Action', a:'radix-icons:component-placeholder'},
       {i:'listPush', n:'Add an item onto a list', a:'material-symbols:add'},
       {i:'listRemoveItem', n:'Remove an item from a list', a:'fluent:person-subtract-16-filled'},
       {i:'listRemoveIndex', n:'Remove item at a position from a list', a:'ic:outline-minus'},
       {i:'reloadDapp', n:'Reload Dapp', a:'tabler:reload'},
       {i:'changeScreen', n:'Change Page', a:'carbon:change-catalog'},
       {i:'toggleMusic', n:'Play/Pause Music', a:'material-symbols:music-note'}];

  if (path[0] === 'pu' || path[0] === 'fe' || path[0] === 'fo' || path[0] === 'as'){
    actions.push({i:'openUrl', n:'Open window with URL', a:'iconoir:open-in-window'});
    actions.push({i:'scrollToPanel', n:'Scroll to a specific panel', a:'fluent:dual-screen-vertical-scroll-20-regular'});
    actions.push({i:'scrollToTop', n:'Scroll to top of page', a:'clarity:scroll-outline-alerted'});
  }

  if (path[0] === 'pu' || path[0] === 'fe' || path[0] === 'fo' || path[0] === 'as' || path[0] === 'oc'){ //the last one indicates that it is the onstart action.
    actions.push({i:'toggleBannerVisibility', n:'Toggle Visibility of a Banner', a:'dashicons:visibility'});
  }

  if (path[4] === 'al'){
    actions.push({i:'hideOwnBanner', n:'Hide This Banner', a:'bxs:hide'});
  }

  if (path[0] === 'pu'){
    actions.push({i:'closePopUp', n:'Close Pop Up', a:'dashicons:visibility'});
  }else if (path[0] === 'as'){
    var searched = SearchForAnEntityWithPath.searchEntity(currentList, path[1]);
    if (searched){
      var xPath = searched.path;
      if (xPath[0] === 'pu'){
        actions.push({i:'closePopUp', n:'Close Pop Up', a:'dashicons:visibility'});
      }

    }

  }

  var inputsAllAround = SearchForAnEntityType.searchEntity(currentList, 'INPUT');
  inputsAllAround.forEach((anInput, index)=>{
    var iT = TypeEvaluation.getInputTypeFromInput(anInput.item); 
    if (iT.t === 'Integer' || iT.t === 'UInteger' || iT.t === 'Text String'|| iT.t === 'Decimal'){
      var pp = anInput.path;
      actions.push({i:'changeInputValue' + pp.join(' '), a:'lucide:form-input', n:'Change Value of ' + DesignerFunctions.getItemTitle(currentList, pp, 'item')});
    }
  })


  var smartContracts = currentList.sc;
  var smartContractKeys = Object.keys(smartContracts);
  smartContractKeys.forEach((anSCKey, index)=>{
    var contractInfo = CoreFns.getContractInfo(currentList, anSCKey);
    if (contractInfo){
      var contractInfoAbi = CoreFns.getAbiFromContractInfo(contractInfo);
      contractInfoAbi.forEach((aAbi, index2)=>{
        if (aAbi.type === 'function' && (aAbi.stateMutability === 'nonpayable' || aAbi.stateMutability === 'payable')){

          var p = checkGotBytes(aAbi.inputs);
          if (!p){
            actions.push({n:contractInfo.contractName + ' ' + aAbi.name, a:'clarity:contract-line', i:'existingContractFn ' + anSCKey + ' ' + aAbi.name + ' ' + aAbi.inputs.length});              
          }
        }
      })

    }
  })    

  


  actions.push({i:'',n:'No Action', a:'fluent:border-none-20-filled'});
  return actions;
}

export function getQuestionsForObjectOrListType(currentList, type, f){
  if (type.t === 'ListType'){
    var o = NamingFns.nameAType(type.c, currentList);
    var childQuestion= [{q:'Value', t:type.c, f, i:'v', c:[]}];
    return [{t:{t:'List', c:childQuestion}, point:type.t, o, i:'s', c:[]}];
  }else if (type.t === 'Object'){
    return type.c.map((aSub, index)=>{
      return {q:aSub.n, t:{t:aSub.t, sp:aSub.sp}, i:aSub.keyOnce, c:[], f};
    })
  }    
}

function getRaw(type, currentList, screenPath, tgt, uuid, currentListFake, path){
      if (type.t === 'Boolean'){
        return 0;
      }else if (type.t === 'Date Time'){
        const d = new Date();
        return d.getTime();
      }else if (type.t === 'UInteger' || type.t === 'Integer' || type.t === 'Decimal'){
        return '0';
      }else if (type.t === 'ScEvent'){
        return 'x1';
      }else if (type.t === 'Object'){ //this is purely for the creation of ownVarDefaultValues. Thats why we use keyOnce.
        var resp = {};
        type.c.forEach((aSub, index)=>{
          resp[aSub.keyOnce] = getRaw({t:aSub.t}, currentList, screenPath.concat([aSub.keyOnce]), '', '');
        })
        return resp;


      }else if (type.t === 'Text String'){
        if (tgt === 'n'){
          return CoreFns.simplName(uuid);
        }else{
          return '';
        }
      }else if (type.t === 'Address'){
        return '';
      }else if (type.t === 'Transaction'){
        return '';
      }else if (type.t === 'List' || type.t === 'ListType' || type.t === 'Mapping'){
        return {};
      }else if (type.t === 'Type'){
        return {i:'UInteger', subs:{}};
      }else if (isDynamicChoice(type)){
        return {i:'', subs:{}};
      }else if (type.t === 'Action'){
        return {t:''};
      }else if (type.t === 'PlayMusic'){
        return '';
      }else if (type.t === 'Panel'){
        return ResponsiveFns.aPanel(screenPath);
      }else if (type.t === 'Alert'){
        return ResponsiveFns.anAlert(currentList, screenPath);
      }else if (type.t === 'PopUp'){
        return ResponsiveFns.aPopUp(currentList);
      }else if (type.t === 'Screen'){
        return ResponsiveFns.changeOfScreen(currentList, screenPath);
      }else if (type.t === 'Music'){
        return ResponsiveFns.changeOfMusic(currentList);
      }else if (type.t === 'Variable'){
        if (currentList.ov){
          var ovKeys = CoreFns.sortedKeyList(currentList.ov);
          if (ovKeys.length > 0){
            return 'ov_' + ovKeys[0];
          }
        }
        return ''

      }else if (type.t === 'Conditional'){
        var resp1 = {o:'1',c:{}};
        for (var i = 0; i < type.o.length; i++){
          var val = type.o[i].i;
          if (+i === 0){
            resp1.o = val;
          }
          resp1.c[val] = {};
          iterateThroughQuestionsInside(type.o[i].c, resp1.c[val], currentListFake, path.concat([tgt, 'c', val]), currentList, screenPath, uuid )
        }
        return resp1;
      }else{
        console.warn(type);
      }

}

export function iterateThroughQuestionsInside(questions, obj, currentListFake, path, currentList, screenPath, uuid){
  questions.forEach((aQuestion, index)=>{
    var tgt = aQuestion.i;
    var typeIn = aQuestion.t;
    var type = CoreFns.getType(typeIn, currentListFake, path, tgt, uuid);
    var resp = ''
    if (aQuestion.d !== undefined){
      resp = aQuestion.d;
    }else{
      resp = getRaw(type, currentList, screenPath, tgt, uuid, currentListFake, path);
    }
    obj[tgt] = resp;

  })
}

